import { EnvironmentDetailsLayout } from "@/routes/environments/details/EnvironmentDetailsLayout";
import { EnvironmentDetailsPage } from "@/routes/environments/details/EnvironmentDetailsPage";
import { EnvironmentLogsPage } from "@/routes/environments/details/EnvironmentLogsPage";
import { EnvironmentTaskRunLogsPage } from "@/routes/environments/details/EnvironmentTaskRunLogsPage";
import { EnvironmentTaskRunsPage } from "@/routes/environments/details/EnvironmentTaskRunsPage";
import { ServiceLogsPage } from "@/routes/environments/details/services/ServiceLogsPage";
import type { RouteObject } from "react-router-dom";

export type EnvironmentDetailsRouteHandle = {
    label?: string;
    /** When true, the route needs full height without ScrollArea wrapper (e.g., for LogViewer) */
    fullHeight?: boolean;
};

export function createEnvironmentDetailsRoute(): RouteObject {
    return {
        path: "details/:environmentId",
        element: <EnvironmentDetailsLayout />,
        children: [
            {
                index: true,
                element: <EnvironmentDetailsPage />,
            },
            {
                path: "logs",
                element: <EnvironmentLogsPage />,
                handle: {
                    label: "Logs",
                    fullHeight: true,
                } satisfies EnvironmentDetailsRouteHandle,
            },
            {
                path: "services/:serviceId/logs",
                element: <ServiceLogsPage />,
                handle: {
                    label: "Service Logs",
                    fullHeight: true,
                } satisfies EnvironmentDetailsRouteHandle,
            },
            {
                path: "tasks",
                element: <EnvironmentTaskRunsPage />,
                handle: {
                    label: "All Task Runs",
                } satisfies EnvironmentDetailsRouteHandle,
            },
            {
                path: "task/:taskId",
                element: <EnvironmentTaskRunsPage />,
                handle: {
                    label: "Task Runs",
                } satisfies EnvironmentDetailsRouteHandle,
            },
            {
                path: "task/:taskId/run/:runId",
                element: <EnvironmentTaskRunLogsPage />,
                handle: {
                    label: "Task Run Logs",
                    fullHeight: true,
                } satisfies EnvironmentDetailsRouteHandle,
            },
        ],
    };
}
